import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Footer = ({ scrollToTop }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div 
              className="bg-white p-3 rounded inline-block mb-6 cursor-pointer"
              onClick={scrollToTop}
            >
              <img 
                src={companyInfo.logo} 
                alt={companyInfo.name}
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Trusted consulting partner for process improvement, operational excellence, and innovation funding for over 15 years.
            </p>
          </div>

          {/* Philcan Industries Links */}
          <div>
            <h4 className="text-[#4A90A4] font-semibold mb-6">Philcan Industries</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-white/60 hover:text-[#4A90A4] text-sm transition-colors duration-300">
                  Process Improvement
                </a>
              </li>
              <li>
                <a href="#services" className="text-white/60 hover:text-[#4A90A4] text-sm transition-colors duration-300">
                  Operational Excellence
                </a>
              </li>
              <li>
                <a href="#process" className="text-white/60 hover:text-[#4A90A4] text-sm transition-colors duration-300">
                  Our Process
                </a>
              </li>
              <li>
                <a href="#about" className="text-white/60 hover:text-[#4A90A4] text-sm transition-colors duration-300">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Philcan Innovation Links */}
          <div>
            <h4 className="text-[#4A90A4] font-semibold mb-6">Philcan Innovation</h4>
            <ul className="space-y-3">
              <li>
                <a href="#sred-basics" className="text-white/60 hover:text-[#4A90A4] text-sm transition-colors duration-300">
                  SR&ED Basics
                </a>
              </li>
              <li>
                <a href="#calculator" className="text-white/60 hover:text-[#4A90A4] text-sm transition-colors duration-300">
                  Innovation Calculator
                </a>
              </li>
              <li>
                <a href="#industries" className="text-white/60 hover:text-[#4A90A4] text-sm transition-colors duration-300">
                  Industries We Support
                </a>
              </li>
              <li>
                <a href="#resources" className="text-white/60 hover:text-[#4A90A4] text-sm transition-colors duration-300">
                  Resources & FAQs
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#4A90A4] font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#4A90A4] mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">{companyInfo.phone}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#4A90A4] mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">{companyInfo.email}</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#4A90A4] mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#privacy" className="text-white/40 hover:text-[#4A90A4] text-sm transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#terms" className="text-white/40 hover:text-[#4A90A4] text-sm transition-colors duration-300">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
